import type { Ref } from 'vue'
import { ref } from 'vue'

export const dataFn = (): { notesShown: Ref } => {
  const notesShown = ref(false)
  return {
    notesShown,
  }
}
